module.exports = __webpack_public_path__ + "static/media/tmc.f7145fed.webp";